import axios from "axios"

function showReferralCodeByHash({hash}) {
    return axios.get(`api/v1/referral-codes/${hash}`)
}
function incrementClicks({code}) {
    return axios.post(`api/v1/referral-codes/${code}/increment-clicks`)
}

function getReferralCode({}, {}, params) {
    return axios.get(`api/v1/referral-code`, {params})
}

function sendUrl({id}, formData) {
    return axios.post(`api/v1/referral-codes/${id}/send-url`, formData)
}

function getUrl({id}) {
    return axios.get(`api/v1/referral-codes/${id}/url`)
}

export const referralService = {
    showReferralCodeByHash,
    incrementClicks,
    getReferralCode,
    sendUrl,
    getUrl
}
